<script setup>
  import { onMounted, ref, watchEffect, reactive, onActivated, computed, onUnmounted } from "vue"
  import { ElMessageBox, ElMessage } from 'element-plus'
  import { useRouter, useRoute } from 'vue-router'
  import { consumption, ssoUpdatePassword, ssoInfo, ssoUpdatePhone, writeEquities, companyPackage, systemConfig} from '../api/index'
  import { smsGetCode } from '../api/authentication'
  import { formatDate } from '../assets/js/date';
  import { setCookie, getCookie, removeCookie } from '../assets/js/cookie';
  import { getDomain } from '../api/setting'
  import Bus from "../js/Bus";
  import { useStore } from 'vuex'
  import PayLoadding from "../components/PayLoadding.vue"
  const store = useStore()
  const router = useRouter()
  const route = useRoute()
  const menuVisible = ref(false)
  const infoMsg = ref('')
  const isHome = ref(false)
  const menuList = ref(['工作台','成员管理','提现记录','统计分析'])
  const activeIndex = ref('/invite')
  const upPassVisible = ref(false)
  const upPhoneVisible = ref(false)
  const formLabelWidth = '80px'
  const upPassFormRef = ref(null);
  const upPhoneFormRef = ref(null)
  const showText = ref(true)
  const second = ref(60)
  const upPassForm = reactive({
    oldPassword: '',
    newPassword: '',
  })
  const upPhoneForm = reactive({
    password: '',
    telephone: '',
    authCode: ''
  })

  const validatorPwd = (rule, value, callback) => {
    if (!value.trim().length) {
      return callback(new Error('请输入密码！'))
    }
    if (/\d/.test(value) && /[a-zA-Z]/.test(value)) return callback();
    callback( new Error("设置6位以上字母+数字组合的密码"));
  };

  const validatorPhone = (rule, value, callback) => {
    console.log(value);
    if (userInfo.value.phone && userInfo.value.phone === value.trim()) {
      return callback(new Error('新手机号不能与原手机号重复'))
    }
    callback()
  }

  const formRules = {
    oldPassword: [
      { required: true, message: '密码不能为空', trigger: 'blur' }
    ],
    newPassword: [
      { required: true, message: '密码不能为空', trigger: 'blur' },
      { min: 6, message: '设置6位以上字母+数字组合的密码', trigger: 'blur' },
      { validator: validatorPwd, triger: 'blur' }
    ],
    password: [
      { required: true, message: '密码不能为空', trigger: 'blur' }
    ],
    telephone: [
      { required: true, message: '手机号不能为空', trigger: 'blur' },
      { validator: validatorPhone, triger: 'blur' }
    ],
    authCode: [
      { required: true, message: '验证码不能为空', trigger: 'blur' }
    ],
  }
  
  const amount = computed({
    get () {
      return store.state.amount
    },
    set (val) {
      store.commit('updateAmount', val)
    }
  })

  const packageList = computed({
    get () {
      return store.state.packageList
    },
    set (val) {
      store.commit('updatePackageList', val)
    }
  })

  const userInfo = computed({
    get () {
      return store.state.userInfo
    },
    set (val) {
      store.commit('updateUserInfo', val)
    }
  })

  const select = (index, indexPath) => {
    // console.log('select', index, indexPath)
    updateActiveMenuIndex(index)
  }
  const updateActiveMenuIndex = (index) => {
    activeIndex.value = index
    // console.log('activeIndex', activeIndex.value)
  }
  const handleOpen = (key, keyPath) => {
    // console.log(key, keyPath);
  }
  const handleClose = (key, keyPath) => {
    // console.log(key, keyPath);
  }

  const handleVisible = (visible) => {
    menuVisible.value = visible
  }

  const logout = () => {
    ElMessageBox.confirm('确定退出登录吗？', '系统提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      confirmButtonClass: 'confirm-button-class',
      type: 'warning'
    }).then(() => {
      removeCookie()
      store.commit('updateUserInfo', {})
      router.replace({ path: '/login' })
    }).catch(() => {})
  }

  const getUserInfo = (pop) => {
    ssoInfo().then(res => {
      if (res) {
        getPackageEquities()
        localStorage.setItem('userInfo', JSON.stringify(res.data))
        store.commit('updateUserInfo', res.data)
        store.commit('updateAmount', res.data.balance)
        store.commit('updatePackageList', res.data.packageList)
        if (pop) {
          return
        }
        // 企业认证状态:0->未通过；1->企业认证通过;2->代理人商认证通过；3->企业认证审核中；4->代理人商认证审核中
        if (res.data.authStatus === 0) {
          store.commit('authType', 0)
          store.commit('updateAuth', true)
        } else if (res.data.authStatus === 1) {
          store.commit('authType', 9)
          store.commit('updateAuth', true)
        } else if (res.data.authStatus === 3) {
          store.commit('authType', 1)
          store.commit('updateAuth', true)
        } else if (res.data.authStatus === 4) {
          store.commit('authType', 10)
          store.commit('updateAuth', true)
        }
      }
    })
  }
  const toAuth = (authStatus) => {
    if (authStatus === 0) {
      // router.push({ 
      //   path: '/company-auth'
      // })
      let baseUrl =  window.location.href.split('#')[0]
      console.log(baseUrl)
      let url = baseUrl + '#/company-auth'
      window.open(url)
    } else {
      store.commit('authType', 1)
      store.commit('updateAuth', true)
    }
  }
  const toAuthAgent = () => {
    localStorage.removeItem('agentForm')
    localStorage.removeItem('agentForm1')
    localStorage.removeItem('agentStep')
    // router.push({ 
    //   path: '/agent-auth'
    // })
    let baseUrl =  window.location.href.split('#')[0]
    let url = baseUrl + '#/agent-auth'
    window.open(url)
  }
  const leftClick = () => {
    router.replace({ path: '/home' })
  }

  const createNew = () => {
    localStorage.removeItem('stepIndex')
    localStorage.removeItem('writeId')
    localStorage.removeItem('allFeatures')
    if (route.path === '/new') {
      router.replace({ path: '/new' })
      Bus.$emit('pageChange', 1)
    } else {
      router.push({ path: '/new' })
    }
  }

  const changePassword = () => {
    if (upPassFormRef.value) {
      upPassFormRef.value.resetFields()
    }
    upPassForm.oldPassword = ''
    upPassForm.newPassword = ''
    upPassVisible.value = true
  }

  const doChangePassword = () => {
    upPassFormRef.value.validate((valid) => {
      let msg =  '请填写密码！'
      // 不通过校验
      if (!valid) return ElMessage.error(msg)
      // 通过校验
      let params = {
        oldPassword: upPassForm.oldPassword,
        newPassword: upPassForm.newPassword,
      }
      ssoUpdatePassword(params).then(res => {
        upPassVisible.value = false
        removeCookie()
        store.commit('updateUserInfo', {})
        router.replace({ path: '/login' })
      }).catch(e => {
        console.log(e)
      }) 
    })
  }

  const changePhone = () => {
    if (upPhoneFormRef.value) {
      upPhoneFormRef.value.resetFields()
    }
    upPhoneForm.password = ''
    upPhoneForm.telephone = ''
    upPhoneForm.authCode = ''
    upPhoneVisible.value = true
  }

  const getCode = () => {
    let phone = upPhoneForm.telephone
    if (!phone.trim()) {
      ElMessage.error('请输入手机号')
      upPhoneFormRef.value.validateField('telephone')
      return
    }
    smsGetCode({phone}).then(res => {
      showText.value = false
      let interval = setInterval(() => {
        let times = -- second.value
        second.value = times < 10 ? '0' + times : times
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        second.value = 60
        showText.value = true
      }, 60000)
    })
  }

  const doChangePhone = () => {
    upPhoneFormRef.value.validate((valid) => {
      // 不通过校验
      if (!valid) return
      // 通过校验
      let params = {
        password: upPhoneForm.password,
        telephone: upPhoneForm.telephone,
        authCode: upPhoneForm.authCode
      }
      ssoUpdatePhone(params).then(res => {
        upPhoneVisible.value = false
        ElMessage.success(res.message)
        getUserInfo(true)
      }).catch(e => {
        console.log(e)
      }) 
    })
  }

  const domainUrl = ref('')

  const goYewu = () => {
    let token = getCookie()
    setCookie(token)
    let url = ''
    if (window.location.origin.indexOf('rjdl.zhizuo.me') !== -1) {
      url = domainUrl.value || process.env.VUE_APP_YWURL1
    } else {
      url = domainUrl.value || process.env.VUE_APP_YWURL
    }
    window.open(url, '_blank')
  }
  const charge = () => {
    store.commit('authType', 2)
    store.commit("updateEquitiesName1", '')
    store.commit('updateChargeType', 0)
    store.commit('updateAuth', true)
  }

  const getData = () => {
    consumption().then(res => {
      infoMsg.value = res.data
    })
  }

  const balanceDetail = () => {
    if (route.path === '/balance') {
      router.push({ path: '/balance'})
      Bus.$emit('balanceChange', 1)
    } else {
      router.push({ path: '/balance'})
    }
  }

  const packageDetail = (item) => {
    if (route.path === '/package') {
      router.push({ path: '/package', query: {
        id: item.id
      }})
      Bus.$emit('packageChange', item.id)
    } else {
      router.push({ path: '/package', query: {
        id: item.id
      }})
    }
  }

  const packageListDetail = () => {
    router.push({ 
      path: '/packageList', 
    })
  }

  const getDomainInfo = () => {
    getDomain().then(res => {
      if (res.data && res.data.domain) {
        if (process.env.VUE_APP_ENV_NAME === 'pro') {
          domainUrl.value = 'https://' + res.data.domain
        } else {
          domainUrl.value = 'https://' + res.data.domain + '/ruanzhu-DQETPJXXZT'
        }
      }
      // else {
      //   domainUrl.value = process.env.VUE_APP_YWURL
      // }
      store.commit('updateDomainUrl', domainUrl.value)
    })
  }

   const equitiesList = ref([])

  const getPackageEquities = () => {
    systemConfig("PACKAGE_EQUITIES").then(res => {
      if (res && res.data) {
        equitiesList.value = JSON.parse(res.data)
      }
    });
  };

  const muitEquities = (list) => {
    let arr = []
    list.forEach(e => {
      let equities = JSON.parse(e.equities)
      if (equities.length > 1) {
        arr.push(
          {
            name: e.packageName,
            equities: equities
          }
        )
      }
    });
    return arr
  }

  const showPayloadding = ref(false)

  onMounted(()=> {
    showPayloadding.value = false
    getDomainInfo()
    getUserInfo()
    Bus.$off("payLoad");
    Bus.$on("payLoad", e => {
      showPayloadding.value = e
    });
  })

  onUnmounted(() => {
    Bus.$off("payLoad");
  });

  onActivated(()=> {
    console.log('layout onActivated')
  })

  watchEffect(()=> {
    console.log('watchEffect:', route.path)
    updateActiveMenuIndex(route.path)
  })
 
</script>

<template>
  <div class="layout">
    <el-container>
      <el-aside width="200px">
        <div class="aside-header">
          <div class="flex-center">
            <div class="aside-icon"><img src="../assets/image/logo1.png" alt=""></div>
            <div class="aside-title">软件工程师协助平台</div>
          </div>
          <div>代理商平台</div>
        </div>
        <el-menu :default-active="activeIndex" 
          class="el-menu-vertical-demo"
          :router="true"
          @open="handleOpen"
          background-color="transparent"
          text-color="#FFFFFF"
          active-text-color="#6196FF"
          @close="handleClose"
          @select="select">
          <el-menu-item index="/customer">
            <template #title>客户管理</template>
          </el-menu-item>
          <el-menu-item index="/reward">
            <template #title>返佣管理</template>
          </el-menu-item>
          <!-- <el-menu-item index="/analysis">
            <template #title>统计分析</template>
          </el-menu-item> -->
          <el-menu-item index="/record">
            <template #title>订单记录</template>
          </el-menu-item>
          <el-menu-item index="/company">
            <template #title>开票信息</template>
          </el-menu-item>
          <el-menu-item index="/setting">
            <template #title>代理商设置</template>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="header">
          <div class="header-nav flex-between">
            <div :class="{'home-title' : !isHome}"
              class="title flex-start">
              <!-- <el-icon style="marginRight: 5px"><House /></el-icon> -->
              <span v-if="userInfo && (userInfo.authStatus === 0 || userInfo.authStatus === 3)"
                @click="toAuth(userInfo.authStatus)"
                style="color: #AAA;cursor: pointer;">{{userInfo.companyName + '（未认证）'}}
              </span>
              <span v-else-if="userInfo.agentLevel && userInfo.agentLevel.name && userInfo.authStatus === 2">
                {{userInfo.companyName + '('+ userInfo.agentLevel.name + ')'}}
              </span>
              <span v-else-if="userInfo">{{userInfo.companyName}}</span>
               <!-- <span class="balance">余额</span> -->
              <!-- <span class="balance-value">{{amount.toFixed(2)}}</span> -->
              <!-- <span @click="balanceDetail" v-if="userInfo.isAdmin || !userInfo.companyId" class="balance2">明细></span> -->
              <span class="balance">套餐剩余</span>
              <div class="balance-all">
                <div class="balance-item" v-for="(item, index) in equitiesList" :key="index">
                  <el-tooltip
                    effect="dark"
                    :disabled="!muitEquities(userInfo.packageMap[item.equities]).length"
                    placement="bottom">
                    <template #content>
                      <div style="width:200px">
                        <div v-for="(it, i) in muitEquities(userInfo.packageMap[item.equities])" :key="i">
                          <span>{{'[' + it.name + ']中含'}}</span>
                          <span v-for="(c, ci) in it.equities" :key="ci">
                            {{'[' + c.name + ']'}}<span v-if="ci !== it.equities.length - 1">、</span>
                          </span>
                          <span>权益</span>
                        </div>
                      </div>
                    </template>
                    <div>
                      <div v-if="userInfo.packageMap[item.equities].length" class="balance-num">
                        {{ userInfo.packageMap[item.equities].reduce((acc, cur) => acc + cur.balance, 0) }}
                        <span v-if="muitEquities(userInfo.packageMap[item.equities]).length" style="display:flex;align-items:center;justify-content: center;color:#ff8f1f;margin-left:2px">
                          <el-icon><Warning /></el-icon>
                        </span>
                      </div>
                      <div v-else class="balance-num">0</div>
                      <div class="balance-text">{{item.name}}</div>
                    </div>
                  </el-tooltip>
                </div>
                <span v-if="(userInfo.isAdmin || !userInfo.companyId)" @click="packageListDetail" class="balance1">更多></span>
              </div>
              <div v-if="userInfo.paySetting * 1 === 1 && (userInfo.isAdmin || !userInfo.companyId)" class="charge" @click="charge">购买套餐</div>
            </div>
            <div class="info">
              <div class="info-create" v-if="userInfo.authStatus === 1" @click="toAuthAgent">成为代理商</div>
              <div class="info-create" v-else-if="userInfo.authStatus === 2" @click="goYewu">业务平台</div>
              <div class="info-icon">
                <img v-if="userInfo && userInfo.icon" :src="userInfo.icon" alt="">
                <el-icon v-else :size="14" color="#FFF"><UserFilled /></el-icon>
              </div>
              <el-dropdown @visible-change="handleVisible" popper-class="popper-item">
                <div class="el-dropdown-link flex-end">
                  <div class="account">{{userInfo.username}}</div>
                  <el-icon v-if="menuVisible" :size="18" class="el-icon--right">
                    <arrow-up />
                  </el-icon>
                  <el-icon v-else :size="18" class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="changePassword">修改密码</el-dropdown-item>
                    <el-dropdown-item @click="changePhone">换绑手机</el-dropdown-item>
                    <el-dropdown-item @click="logout">安全退出</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <el-main id="main">
          <!-- <router-view/> -->
          <router-view v-slot="{ Component, route }">
            <keep-alive :exclude="['balance', 'package', 'packages']">
              <component :is="Component" :key="route.name"></component>
            </keep-alive>
          </router-view>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog v-model="upPassVisible" title="修改密码">
      <el-form :model="upPassForm" :rules="formRules"
            ref="upPassFormRef">
        <el-form-item label="旧密码" prop="oldPassword" :label-width="formLabelWidth">
          <el-input type="password" show-password placeholder="请输入旧密码" v-model="upPassForm.oldPassword" :disabled="isEdit" autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword" :label-width="formLabelWidth">
          <el-input type="password" show-password placeholder="设置6位以上字母+数字组合的密码" v-model="upPassForm.newPassword" autocomplete="new-password" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <div class="add_submit" @click="doChangePassword">
            确定
          </div>
          <div class="add_cancel" @click="upPassVisible = false">取消</div>
        </span>
      </template>
    </el-dialog>
    <el-dialog style="width: 490px" v-model="upPhoneVisible" title="换绑手机">
      <el-form :model="upPhoneForm" :rules="formRules"
            ref="upPhoneFormRef">
        <el-form-item label="原手机号" :label-width="formLabelWidth">
          <div>{{userInfo.phone}}</div>
        </el-form-item>
        <el-form-item label="密码" prop="password" :label-width="formLabelWidth">
          <el-input type="password" show-password placeholder="请输入登录密码" v-model="upPhoneForm.password" autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="新手机号" class="phone-code" prop="telephone" :label-width="formLabelWidth">
          <el-input oninput="value=value.replace(/\D/g, '')" v-model="upPhoneForm.telephone" placeholder="请输入新手机号码" :maxlength="11" type="text" autocomplete="off" />
          <el-button class="code-btn" @click="getCode" link :disabled="!showText">{{ showText ? '获取验证码': second + 's后重新获取' }}</el-button>
        </el-form-item>
        <el-form-item label="验证码" prop="authCode" :label-width="formLabelWidth">
          <el-input v-model="upPhoneForm.authCode" placeholder="请输入短信验证码" type="text" autocomplete="off" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <div class="add_submit" @click="doChangePhone">
            确定
          </div>
          <div class="add_cancel" @click="upPhoneVisible = false">取消</div>
        </span>
      </template>
    </el-dialog>
    <PayLoadding v-model="showPayloadding"></PayLoadding>
  </div>
</template>


<style scoped lang="less">
:deep(.el-dropdown-menu__item:not(.is-disabled):focus) {
  color: #FFC300 !important;
  background-color: #FFF;
}

.layout {
  .phone-code {
    .code-btn {
      position: absolute;
      right: 16px;
      color: #FFC300;
    }
  }
  :deep(.el-dialog) {
    width: 400px;
  }
  :deep(.el-dialog__header) {
    text-align: left;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add_submit {
      width: 100px;
      height: 31px;
      line-height: 31px;
      background: #1A1A1A;
      border-radius: 50px;
      font-size: 16px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #FFC300;
      text-align: center;
      cursor: pointer;
    }
    .add_cancel {
      width: 100px;
      height: 29px;
      line-height: 29px;
      border-radius: 50px 50px 50px 50px;
      opacity: 1;
      border: 1px solid #FFC300;
      font-size: 16px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #FFC300;
      margin-left: 16px;
      text-align: center;
      cursor: pointer;
    }
  }
  .el-header {
    padding: 0;
    height: 73px !important;
    position: fixed;
    left: 200px;
    width: calc(100% - 200px);
    z-index: 99;
  }
  .el-aside {
    background-image: url("../assets/image/aside-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    position: fixed;
    height: 100vh;
    z-index: 999;
    .aside-header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 134px;
      font-size: 16px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 500;
      color: #FFFFFF;
      .aside-icon {
        width: 15px;
        height: 21px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        margin-bottom: 8px;
      }
      .aside-title {
        color: #FFC300;
        margin-bottom: 8px;
      }
    }
  }
  .el-menu {
    border-right: none;
  }
  .el-menu-item {
    width: 200px !important;
    height: 55px !important;
    line-height: 55px !important;
    text-align: center;
    display: inline-block;
    font-weight: bold;
    font-size: 16px;
  }

  .el-menu-item.is-active {
    background-color: #FFC300 !important;
    color: #1A1A1A;
  }

  .el-menu-item:hover {
    background-color: #FFC300 !important;
    color: #1A1A1A !important;
  }
  .header {
    .header-nav {
      padding: 0px 40px;
      height: 73px;
      background: #FFFFFF;
      box-shadow: 0px 8px 24px 0px rgba(149,157,165,0.2);
      font-size: 16px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #1A1A1A;
      :deep(:focus-visible) {
        outline: none !important;
      }
      :deep(.el-dropdown) {
        color: inherit;
      }
      .info {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-dropdown-link {
          cursor: pointer;
        }
        .account {
          font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          color: #1A1A1A;
          margin: 0 8px 0 18px;
        }
        .info-create {
          width: 133px;
          height: 39px;
          border-radius: 100px;
          opacity: 1;
          border: 1px solid #FFC300;
          font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          color: #FFC300;
          box-sizing: border-box;
          cursor: pointer;
          margin-right: 58px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .info-icon {
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: #FFC300;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }
        }
      }
      .home-title {
        // cursor: pointer;
      }
      .title {
        font-weight: bold;
        .balance {
          font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          color: #AAAAAA;
          margin: 0 8px 0 24px;
        }
        .balance-value {
          font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          color: #FFC300;
        }
        .balance-all {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          background: #F9F9F9;
          padding: 2px 24px;
          .balance-item + .balance-item {
            margin-left: 16px;
          }
          .balance-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .balance-num {
              font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
              color: #6196ff;
              font-size: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .balance-text {
              font-size: 12px;
              color: #999;
              font-weight: 400;
            }
          }
        }
        .balance-value1 {
          font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          color: #FFC300;
          margin-right: 8px;
        }
        .balance-value2 {
          font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          color: #9E9E9E;
          margin-right: 8px;
        }
        .balance1 {
          margin-left: 16px;
          font-size: 12px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          color: #9E9E9E;
          cursor: pointer;
        }
        .balance2 {
          margin-left: 8px;
          font-size: 12px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          color: #9E9E9E;
          cursor: pointer;
        }
        .charge {
          margin-left: 16px;
          width: 64px;
          height: 19px;
          line-height: 19px;
          background: #FFC300;
          border-radius: 100px;
          font-size: 12px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          color: #FFFFFF;
          margin-right: 17px;
          text-align: center;
          cursor: pointer;
        }
        .fee-info {
          font-size: 12px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          color: #AAAAAA;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          cursor: pointer;
          span {
            margin-left: 4px;
          }
        }
      }
      .logout {
        cursor: pointer;
      }
    }
  }
  .el-main {
    margin-top: 73px;
    margin-left: 200px;
    padding: 0px 0 0;
    min-height: calc(100vh - 73px);
    overflow: unset;
    background: #FAFAFA
  }
}
.package-body {
  max-height: 800px;
  overflow-y: auto;
  padding-right: 12px;
}
.package-pop {
  padding-bottom: 8px;
  .package-title {
    height: 23px;
    font-size: 12px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 500;
    color: #1A1A1A;
    line-height: 23px;
    
  }
  .package-item {
    height: 19px;
    font-size: 12px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    color: #767676;
    line-height: 19px;
    .item-value {
      color: #FFC300;
      margin-left: 16px;
    }
    .package-detail {
      color: #FFC300;
      cursor: pointer;
    }
  }
}
.package-pop + .package-pop {
  border-top: 1px solid #D8D8D8;
  padding-top: 8px;
}
</style>